/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { PbHousePlanFinderDialogComponent } from './pb-house-plan-finder-dialog.component';

export const pbHousePlanFinderDialogRoute = createDialogRoute({
  component: PbHousePlanFinderDialogComponent,
});
